import React from 'react'
import styled from 'styled-components'
import { useWebsiteContext } from '../context/website_context'
import logo from '../assets/logo.png'
import { FaBars } from 'react-icons/fa'
import { Link, useLocation } from 'react-router-dom'
import { links } from '../utils/constants'

const Navbar = () => {

  const {openSidebar} = useWebsiteContext();
  const location = useLocation();

  return (
    <NavContainer>
        <div className="nav-center">
            <div className="nav-header">
                <Link to="/">
                    <img src={logo} alt="jessica tacoen logo" />
                </Link>
                <button type="button" className="nav-toggle" onClick={openSidebar}>
                    <FaBars />
                </button>
            </div>
            <ul className="nav-links">
                {
                    links.map(link => {
                        const {id, text, url} = link;

                        return (
                            <li key={id}>
                                <Link to={url} className={location.pathname === `${url}` ? 'navbar-link-active' : ''}>{text}</Link>
                            </li>
                        )
                    }) 
                   
                }
        
            </ul>
        
        </div>
      
    </NavContainer>
  )
}

const NavContainer = styled.nav`
        position: fixed;
        top: 0;
        height: 5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
        background-color: var(--website-main-color-dark-opacity);

        .nav-center {
            width: 100vw;
            margin: 0 auto;
            max-width: var(--max-width);
        }
        .nav-header {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            img {
                width: 250px;
                padding-left: 1rem;
                
            }
        }
        .nav-toggle {
            background: transparent;
            border: transparent;
            color: var(--website-secondary-color);
            padding-right: 2rem;
            cursor: pointer;
            svg {
                font-size: 2rem;
            }
        }
        .nav-links {
            display: none;
            align-items: center;
            justify-content: center;
            a {
                text-transform: lowercase !important;
            }
            
        }
        .navbar-link-active {
            cursor: default; 
            font-weight: bold;
        
            &:after { 
                    transform: scaleX(1) !important;  
                    transition: transform 250ms ease-in-out;
                }
        }

        @media (min-width: 1000px) {
            .nav-toggle {
                display: none;
            }
            .nav-center {
                display: grid;
                grid-template-columns: auto 1fr auto;
                align-items: center;
            }
            .nav-links {
                display: flex;
                align-content: center;
                justify-content: center;
                margin-top: 1rem;
            
                a {
                    color: white;
                    font-size: 1.2rem;
                    text-transform: capitalize;
                    letter-spacing: var(--spacing);
                    display:inline-block;
                    margin-left: 1.5rem;
                    margin-right: 1.5rem;
                    
                    &:after {
                        display:block;
                        content: '';
                        border-bottom: 4px solid white;   
                        transform: scaleX(0);  
                        transition: transform 250ms ease-in-out;
                        margin-top: 0.5rem;
                    }
                    &:hover:after{
                        transform: scaleX(1);
                    }
                }
            }
        }
  `

export default Navbar
